import axios from "axios";
import env from "../env";
import { zoomRecordingBody } from "src/Interfaces/zoom";

const api_url = env.API_URL;

export const createRecording = async (body: zoomRecordingBody, token: string) => {
    try {
        const response = await axios.post(`${api_url}sessions/past-links`,body,{
                headers: {
                    Authorization: `Bearer ${token}`
                },
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
};

export const getRecording = async (programme: string, stream: string, subject: string, token: string) => {
    try {
        const response = await axios.get(`${api_url}sessions/past-links`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                programme,
                stream,
                subject
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteRecording = async (programme: string, stream: string, subject: string, id: string, instructorId: string, token: string) => {
    try {
        const response = await axios.delete(`${api_url}sessions/past-links`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                programme,
                stream,
                subject,
                id,
                instructorId
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const setVisibile = async (programme: string, stream: string, subject: string, id: string, instructorId: string, activeStatus: boolean, token: string) => {
    try {
        const response = await axios.put(`${api_url}sessions/past-links`,{} ,{
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                programme,
                stream,
                subject,
                id,
                instructorId,
                activeStatus
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getCurrentMeeting = async (programme: string, stream: string, subject: any, token: string) => {
    try {
        const response = await axios.get(`${api_url}sessions/current-link` ,{
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                programme,
                stream,
                subject
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const setCurrentMeeting = async (body:any, token: string) => {
    try {
        const response = await axios.post(`${api_url}sessions/schedule`,body,{
                headers: {
                    Authorization: `Bearer ${token}`
                },
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteMeeting = async (programme: string, stream: string, subject: string, id: string, instructorId: string, token: string) => {
    try {
        const response = await axios.delete(`${api_url}sessions/current-link`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                programme,
                stream,
                subject,
                id,
                instructorId
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}